import React from "react"
import ajlogo from './images/ajlogo.png'

function HomeScreen(){
    return(
      <div className="fullscreen homepage">
      <br/>
          <a className="text-center totop" href="https://aljazeera.com" target="_blank">
            <img className="align-bottom" alt="Al Jazeera" width="100px" height="auto" src={ajlogo}/>
          </a>
      </div>
    )
}
export default HomeScreen